<template>
  <div>
    <div class="row top">
      
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Δομές</u></h4>
        </div>
      </div>
      <div>
        <DxLoadIndicator id="image-indicator" :height="40" :width="40" :visible="loadIndicatorVisible" />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid :data-source="structures" :allow-column-reordering="true" :allow-column-resizing="true"
        :column-auto-width="true" :show-borders="true" key-expr="Id" :show-row-lines="true"
        :row-alternation-enabled="true">
        <DxPaging :page-size="20" />
        <DxEditing :allow-updating="false" :allow-adding="false" mode="row" :use-icons="true" />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <DxColumn caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">
        </DxColumn>
        <DxColumn caption="Περιγραφή" data-field="Description" data-type="string" :visible="true" alignment="left">
        </DxColumn>
        <DxColumn caption="Ενεργή" data-field="IsActive" data-type="boolean" :visible="true" alignment="center">
        </DxColumn>
        <DxColumn type="buttons">
          <DxButton hint="Πληροφορίες" icon="info" :on-click="structureInfoClick" />
        </DxColumn>

        <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
        <template #masterDetailTemplate="{ data: masterrow }">
          <DetailTemplate :template-data="masterrow" />
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import mainService from "../../services/mainService";
import router from "../../router";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxSearchPanel,
  DxButton,
  DxMasterDetail,
} from "devextreme-vue/data-grid";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import DetailTemplate from "./structureContractCategories";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxSearchPanel,
    DxButton,
    BackButton,
    DxLoadIndicator,
    DetailTemplate,
    DxMasterDetail,
  },
  data() {
    return {
      structures: [],
      loadIndicatorVisible: false,
    };
  },
  created() {},
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      const res = await mainService.get(
        `/structures/GetStructuresByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.structures = res.data;
    },
  },
  methods: {
    structureInfoClick(e) {
      router.replace(`/structure/${e.row.data.Id}`);
    },
    async getStructures() {
      const res = await mainService.get(
        `/structures/GetStructuresByUserAndOrganization?organizationId=${this.organizationId}`
      );
      this.structures = res.data;
    },
  },
  async mounted() {
    this.loadIndicatorVisible = true;
    this.getStructures();
    this.loadIndicatorVisible = false;
  },
};
</script>